import { Timestamp } from 'firebase/firestore';

export enum MeetingsTypes {
    GET_LIST_MEETINGS = '@meetings/GET_LIST_MEETINGS',
    REQUEST_GET_LIST_MEETINGS = '@meetings/REQUEST_GET_LIST_MEETINGS',
    REQUEST_UPDATE_MEETING_NOTE = '@meetings/REQUEST_UPDATE_MEETING_NOTE',
    UPDATE_MEETING_NOTE = '@meetings/UPDATE_MEETING_NOTE',
    MEETINGS_ERROR = '@meetings/MEETINGS_ERROR',
    CLEAR_MEETINGS_ERROR = '@meetings/CLEAR_MEETINGS_ERROR',
}

export type MeetingFirebase = {
    id: string;
    cancelled: boolean;
    coachId: string;
    date: Timestamp;
    time: string;
    userId: string;
    meetingNote?: string;
};

export type Meeting = {
    id: string;
    date: Date;
    time: string;
    meetingNote?: string;
};

export enum MeetingType {
    Confirmed = 'confirmed',
    Cancelled = 'cancelled',
}

export type MeetingsMap = { [key in MeetingType]: Record<string, Meeting[]> };

export type MeetingsState = {
    isLoading: boolean;
    meetings: MeetingsMap;
    error?: string;
};

export type MeetingsAction<Payload> = {
    type: MeetingsTypes;
    payload: Payload;
};
